// ANCHOR Base
import { Block } from 'baseui/block';
import { LabelMedium } from 'baseui/typography';
import { styled } from 'baseui';
import { ChevronDown, ChevronUp } from 'baseui/icon';

// ANCHOR Hooks
import { useToggle } from '@lyon/utils/hooks/useToggle';

// ANCHOR Result
import { ICourseDescription } from '@lyon/utils/api/results/course';

// ANCHOR Components
import { ContentListSkeleton } from '@lyon/components/utils/ContentList/ContentListSkeleton';

// ANCHOR Styles
import { NORMAL, PURPLE } from './styles';

interface IProps {
  list?: ICourseDescription[];
}

const ClickableDiv = styled('div', {
  marginTop: '8px',
  background: 'none',
  cursor: 'pointer',
});

const MORE = <ChevronDown size={20} />;
const LESS = <ChevronUp size={20} />;

export function LyonCourseRequirementList({ list }: IProps) {
  const { toggle, state: shouldTruncate } = useToggle(false);

  const truncatedList = shouldTruncate ? list : list?.slice(0, 3);

  if (truncatedList && list) {
    if (truncatedList.length) {
      return (
        <Block
          display="grid"
          gridRowGap="4px"
        >
          {
            truncatedList.map((item) => (
              <Block
                key={item.id}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Block display="flex" marginLeft="8px">
                  <LabelMedium marginRight="12px" overrides={NORMAL}>
                    •
                  </LabelMedium>
                  <LabelMedium overrides={NORMAL}>
                    {`${item.description}`}
                  </LabelMedium>
                </Block>
              </Block>
            ))
          }
          {list.length > 3 && (
            <ClickableDiv onClick={toggle}>
              <LabelMedium overrides={PURPLE}>
                {`Show ${shouldTruncate ? 'less' : 'more'}`}
                {' '}
                {shouldTruncate ? LESS : MORE}
              </LabelMedium>
            </ClickableDiv>
          )}
        </Block>
      );
    }
  }

  return <ContentListSkeleton />;
}
